/* import __COLOCATED_TEMPLATE__ from './emoji-group-sections.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./emoji-group-sections.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));